var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "noselect" },
    [
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "text-center mt-7" },
          [
            _c("h4", [_vm._v("Setup Kiosk System")]),
            _c("div", { staticClass: "spacer-15" }),
            _c("div", [
              _vm._v(" isKiosk: " + _vm._s(_vm.$store.getters.isKiosk) + " "),
            ]),
            _c("div", [
              _vm._v(" table: " + _vm._s(_vm.$store.getters.table) + " "),
            ]),
            _vm.$store.getters.isKiosk
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "spacer-15" }),
                    _c("div", { staticClass: "superCenter" }, [
                      _c(
                        "div",
                        { staticClass: "d-inline-block myBox" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Betrag (inkl. Trinkgeld)",
                              type: "number",
                              step: "0.01",
                              rules: [_vm.validateDouble],
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.doubleValue,
                              callback: function ($$v) {
                                _vm.doubleValue = $$v
                              },
                              expression: "doubleValue",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Trinkgeld (optional)",
                              type: "number",
                              step: "0.01",
                              rules: [_vm.validateDouble],
                              outlined: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.doubleTrinkgeld,
                              callback: function ($$v) {
                                _vm.doubleTrinkgeld = $$v
                              },
                              expression: "doubleTrinkgeld",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "btn-df" },
                              on: { click: _vm.triggerTerminalPayment },
                            },
                            [_vm._v(" Trigger Payment ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c("div", { staticClass: "d-inline-block myBox" }, [
                        _c("h3", [_vm._v("Output Params:")]),
                        _c("div", [
                          _vm._v(
                            "Last Update: " + _vm._s(_vm.lastUpdateOutputParams)
                          ),
                        ]),
                        _c("div", { staticStyle: { "white-space": "pre" } }, [
                          _vm._v(_vm._s(_vm.paramsString)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "superCenter" }, [
                      _c("div", { staticClass: "d-inline-block myBox" }, [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("h3", [_vm._v("All Params:")]),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-mini",
                                on: { click: _vm.readAllParams },
                              },
                              [_vm._v("Refresh ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticStyle: { "white-space": "pre" } }, [
                          _vm._v(_vm._s(_vm.allParamsString)),
                        ]),
                      ]),
                    ]),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.checkTerminalServiceActive },
                      },
                      [_vm._v(" Check Terminal Service active ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.getCurrentTerminalIp },
                      },
                      [_vm._v(" Get current terminal IP ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.clickTriggerDiagnose },
                      },
                      [_vm._v(" Trigger Diagnose ")]
                    ),
                    _c("div", { staticClass: "spacer-15" }),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "btn-df" },
                        on: { click: _vm.finishSetup },
                      },
                      [_vm._v(" Finish Setup and Open Start Page ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "spacer-20" }),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickDebugParams },
                  },
                  [_vm._v(" Öffne Konfigurationsparameter ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickSetupShowHide },
                  },
                  [_vm._v(" Setup Button aus/einblenden ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.clickBestellungen },
                  },
                  [_vm._v(" Letzte Bestellungen ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "btn-mini" },
                    on: { click: _vm.dummyPrint },
                  },
                  [_vm._v(" Print Dummy Page ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "spacer-40" }),
            _c(
              "v-btn",
              { attrs: { color: "btn-mini" }, on: { click: _vm.exitKiosk } },
              [_vm._v(" Exit Kiosk Mode ")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }